<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <div class="row" :style="fblabelposition == 'right'? 'flex-direction: row-reverse;': ''">
      <div class="col-form-label" :class="fblabelposition == 'top' ? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12 text-center' : fblabelposition == null|| undefined || '' ? 'col-sm-12' :'col-sm-2'"  v-if="fbhidelabel !== 'true'">     
        <label><b style="color: red;" v-if="fbrequired == 'true'">*</b> {{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      </div>
      <div class="col-form-input" :class="fblabelposition == 'top'? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12' : (fblabelposition == null || undefined || '')? 'col-sm-12' : 'col-sm-10'">
     
        <select
          :id="id"
          ref="select"
          class="form-control form-control-select2 col-sm-12"
          :data-placeholder="placeholder || ' '"
          v-bind:value="value"
          :required="fbrequired == 'true' ? true: false"
          :multiple="multiple || false"
         :readonly="checkReadonly(isedit, fbsubmitcanchange,fbreadonly,approvaledit)"
        >
          <option v-for="option in cusfboptions" :value="option.id" :key="option.id" :disabled="option.Disabled === true">{{ displayField ? option[displayField] : option.text }}</option>
        </select>
        <!-- <input v-if="fbreadonly" type="text" :placeholder="placeholder" class="form-control" :value="valueText" :readonly="fbreadonly == 'true' ? true : false"> -->
        <label
          v-if="isValid === false"
          id="basic-error"
          class="validation-invalid-label"
          for="basic"
        >{{ $t('ui.SYS00016') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import helper from "@/vueHelper";

export default {
  // [{Key: 'a', Value: 'a'}, {Key: 'b', Value: 'b'}]
  name: "SelectBox",
  props: [
    "id",
    "fblabel",
    "fbsupportmultiplelanguages",
    "placeholder",
    "value",
    "fblabelposition",
    "fbinvisible",
    "fboptions",
    "fbreadonly",
    "fbrequired",
    "inDialog",
    "fbhidelabel",
    "multiple",
    "labelwidth",
    "displayField",
    "ajaxurl",
    "ajaxparam",
    "isedit",
    "fbsubmitcanchange",
    "approvaledit",
    "createuser"
  ],
  data() {
    return {
      val: [],
      isValid: true,
      inited: false,
      select2: null,
      cusfboptions:this.fboptions
    };
  },
  methods: {


    checkReadonly(isedit,fbsubmitcanchange,fbreadonly,approvaledit) {
      let readonly = true;
      if(fbsubmitcanchange){
        if(approvaledit||isedit){
          readonly = false;
        }else{
          readonly = true;
        }
      }
      else if (isedit) {
        if (fbreadonly == "true") {
          readonly = true;
        } else {
          readonly = false;
        }
      } else {
        readonly = true;
      }
   console.log(readonly);
      return readonly;
    },
    setFocus() {
      this.$refs.select.focus();
    },
    setValid(val) {
      this.isValid = val;

      if (!val) {
        $(this.$refs.select)
          .next(".select2-container")
          .addClass("invalid");
      } else {
        $(this.$refs.select)
          .next(".select2-container")
          .removeClass("invalid");
      }
    },
    isFieldValid() {
      return (
        !this.required || (this.required && this.val && this.val.length > 0)
      );
    },
    resetValue() {
      this.isValid = true;
      this.val = [];
      $(this.$refs.select)
        .val(this.val)
        .trigger("change");
    },

  },
  computed: {
    labelCol() {
      return this.labelwidth || 2;
    }
  },
  mounted() {
    //this.init()

    //this.select2 = $(this.$el).find("select");
    this.select2 = $(this.$refs.select);
    let vm = this;

    var ajaxOpt = {
      delay: 250,
      url: config.serverURI + this.ajaxurl,
      dataType: "json",
      type: "POST",
      processResults: function(data, param) {
        if (data.code == 200) {
          
          return {
            results: data.data.lookups
          };
        } else {
          alert("status code: " + data.code + " Message " + data.message);
          return {
            results: null
          };
        }
      },
      data: function(params) {
        // ajaxparam
        
        var queryParameters = {
          SessionID: vm.$helper.getSessionID(),
          LocaleCode: vm.$helper.getLocaleCode(),
          Parameters:{ 
             createuser:vm.createuser
          }
          ,
          ApiKey: config.apiKey,
          ApiSystemName: config.apiSystemName
        };
        return JSON.stringify(queryParameters);
      },
      headers: {
        "Content-type": "application/json; charset=utf-8"
      }
    };

    this.$nextTick(() => {
      setTimeout(function() {
        vm.select2
          .select2({
            ajax: ajaxOpt,
            allowClear: true,

          })
          .trigger("change")
          // emit event on change.
          .on("change", function() {
            console.log('changed');
            vm.$emit("updatePreparerID",  this.value) ;
          }).on("select2:unselecting", function() {
            $(this).data("unselecting", true);
          }).on("select2:opening", function(e) {
            if ($(this).data("unselecting")) {
              $(this).removeData("unselecting");
              e.preventDefault();
            }
          })

      if(vm.fbsubmitcanchange=="true"){
          if(vm.approvaledit||vm.isedit){
        vm.select2
          .prop("disabled",false );
      }else{
           vm.select2
          .prop("disabled",true );
      }
        }else  if (vm.isedit) {
          if (vm.fbreadonly == "true") {
            vm.select2
          .prop("disabled",true );
          } else {
              vm.select2
          .prop("disabled",false );
          }
        } else {
            vm.select2
          .prop("disabled",true );
        }
          
    
      }, 250);

  
   
    })
  },
  updated() {
  },
  destroyed() {
    this.select2.off().select2("destroy");
  },
  watch: {
 
  }
};
</script>
<style>
.select2-selection--single .select2-selection__arrow:after {
  margin-right: 10px;
}
.select2-selection__placeholder {
  font-size: 0.8rem;
}
.select2-selection__rendered {
  padding-left: 13px !important;
  padding-top: 2px;
}
.select2-selection.select2-selection--single {
  /* min-height: 35px; */
  min-height: 42px;
}
.select2-selection--single {
  padding: 5px 0;
  /* border-bottom: 0px solid !important; */
}
.select2-search--inline,
.select2-search__field {
  width: 100% !important;
}
.select2-container--default .select2-selection--single .select2-selection__clear {
  padding-right: 20px;
  font-size: 24px;
}
</style>
